import { Page } from "@ui/page/Page";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { Ban, ListChecks, Shield, Settings2, Link2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { GD } from "src/GD";
import { hasRole } from "src/permissions";
import { AUTH_STATE } from "src/services/AuthService";
import { RuleBlocksTab } from "./administration/RuleBlocksTab";
import { BansTab } from "./administration/BansTab";
import { BanRulesTab } from "./administration/BanRulesTab";
import { RuleAssignmentsTab } from "./administration/RuleAssignmentsTab";

export const AdministrationPage = () => {
	const { t } = useTranslation();
	const [project] = GD.B_SELECTED_PROJECT.use();
	const authState = GD.S_AUTH_STATUS.use([]);
	const [user] = GD.REQ_PROFILE.useValue(undefined, undefined, [project?.id, authState]);
	const roles = user?.projects.find(item => item.id === project?.id)?.roles;
	if (authState !== AUTH_STATE.AUTHORIZED || !project || !user || !hasRole(roles, "admin")) return null;

	return <Page label={t("nav.administration")} description={t("administration.description")} icon={<Shield size={20} />}>
		<Tabs variant="modern">
			<TabItem title={t("administration.blocks")} icon={<ListChecks size={16} />}>
				<RuleBlocksTab key={`${project.id}:${user.id}`} projectId={project.id} userId={user.id} />
			</TabItem>
			<TabItem title={t("bans.title")} icon={<Ban size={16} />}>
				<BansTab key={`${project.id}:${user.id}`} projectId={project.id} userId={user.id} />
			</TabItem>
			<TabItem title={t("banRules.title")} icon={<Settings2 size={16} />}>
				<BanRulesTab key={`${project.id}:${user.id}`} projectId={project.id} userId={user.id} />
			</TabItem>
			<TabItem title={t("trafficAssignments.allAssignments")} icon={<Link2 size={16} />}>
				<RuleAssignmentsTab key={`${project.id}:${user.id}`} projectId={project.id} userId={user.id} />
			</TabItem>
		</Tabs>
	</Page>;
};
